import { NgComponentOutlet } from '@angular/common';
import { Component, input, Type } from '@angular/core';
import { IconBase } from '../../../shared/components/icons/icon-base';
import { IsActiveMatchOptions, RouterModule } from '@angular/router';

@Component({
  selector: 'sidebar-item-v2',
  imports: [NgComponentOutlet, RouterModule],
  templateUrl: './sidebar-item-v2.html',
  styleUrl: './sidebar-item-v2.scss',
})
export class SidebarItemV2 {
  activeOptions = input<{ exact: boolean } | Partial<IsActiveMatchOptions>>({
    exact: false,
  });
  icon = input.required<Type<IconBase>>();
  label = input.required<string>();
  routerLink = input<string | null>(null);
}
